import RevokeAccessModal from './RevokeAccessModal';

export default RevokeAccessModal;
